<template>
  <v-menu v-if="sections.length > 1" offset-y bottom :z-index="30">
    <template #activator="{ on }">
      <button type="button" class="app-launcher__btn" title="Ir a otra sección" v-on="on">
        <v-icon size="20">mdi-view-grid</v-icon>
      </button>
    </template>
    <v-list dense class="app-launcher__list">
      <v-list-item
        v-for="section in sections"
        :key="section.id"
        :class="{ 'app-launcher__item--active': section.id === activeId }"
        @click="go(section)"
      >
        <v-list-item-icon class="mr-3">
          <v-icon size="18">{{ section.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ $vuetify.lang.t('$vuetify.menu.' + section.titleKey) }}
          </v-list-item-title>
        </v-list-item-content>
        <v-icon v-if="section.id === activeId" size="16" class="ml-2">mdi-check</v-icon>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import { navSections, activeSectionId } from '@/router/nav-model'

export default {
  name: 'AppLauncher',
  computed: {
    ...mapGetters('auth', ['getUser']),
    sections() {
      return navSections(this.getUser)
    },
    activeId() {
      return activeSectionId(this.$route.name)
    },
  },
  methods: {
    go(section) {
      if (section.id === this.activeId) return
      // .catch silencia el "Navigation cancelled" que Vue Router 3 arroja con
      // doble clic rápido; la navegación final completa igual.
      this.$router.push(section.route).catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
/* Con una sola sección visible el componente no se renderiza (v-if en el
   v-menu): un botón que abre un panel de un solo ítem, apuntando a donde el
   usuario ya está, es ruido. Tras el gateado de la fase 0 es un caso real: un
   operador sin permisos de módulo solo ve Mapa. */
.app-launcher__btn {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: transparent;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: background 0.15s, border-color 0.15s;
  color: var(--kln-text-muted, rgba(255, 255, 255, 0.7));

  &:hover {
    background: var(--kln-surface-hover, rgba(255, 255, 255, 0.06));
    border-color: var(--kln-border, rgba(255, 255, 255, 0.1));
  }
}

.app-launcher__list {
  min-width: 220px;
  background: var(--kln-surface, #0d1121) !important;
}

.app-launcher__item--active {
  background: var(--kln-surface-hover, rgba(255, 255, 255, 0.06));
}
</style>
